import { ApiPriority } from './shared'

export const mapPriority = ({
  description: description,
  icon_url: iconUrl,
  id: id,
  name: name
}: ApiPriority) => ({
  description,
  iconUrl,
  id,
  name
})
